// extracted by mini-css-extract-plugin
export default {"commentsTab":"commentsTabYdD5o"};